export default obj => Object.keys(obj).length !== 0
